/*
 * File: directive.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-14 8:02:02 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */
import Vue from 'vue';

// document监听enter事件
import AutoEnter from './autoEnter/index';

// 全局按钮权限控制
import authBotton from './authButton/index';

// dom节点的回车触发事件
import domEnter from './domEnter/index';
// 拖拽缩放
import drag from './drag/index';
// 按钮点击防抖
import debounceClick from './debounceClick/index';
/** 监听元素变化 */
import resize from './resize';

const install = function(Vue) {
  Vue.directive('yxyEnter', AutoEnter);
  Vue.directive('domEnter', domEnter);
  Vue.directive('authBotton', authBotton);
  Vue.directive('drag', drag);
  Vue.directive('debounceClick', debounceClick);
  Vue.directive('resize', resize);
};

Vue.use(install); // eslint-disable-line
